const KAKAO_POSTCODE_SCRIPT_ID = "kakao-postcode-sdk";
const KAKAO_POSTCODE_SCRIPT_URL = "https://t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";

let kakaoPostcodeLoadPromise = null;

export const loadKakaoPostcodeSdk = () => {
    if (window.kakao && window.kakao.Postcode) {
        return Promise.resolve(window.kakao);
    }

    if (kakaoPostcodeLoadPromise) {
        return kakaoPostcodeLoadPromise;
    }

    const existingScript = document.getElementById(KAKAO_POSTCODE_SCRIPT_ID);

    kakaoPostcodeLoadPromise = new Promise((resolve, reject) => {
        const onLoad = () => {
            if (window.kakao && window.kakao.Postcode) {
                resolve(window.kakao);
                return;
            }

            kakaoPostcodeLoadPromise = null;
            reject(new Error("Kakao postcode SDK is loaded, but kakao.Postcode is unavailable."));
        };

        const onError = () => {
            kakaoPostcodeLoadPromise = null;
            reject(new Error("Failed to load Kakao postcode SDK."));
        };

        if (existingScript) {
            existingScript.addEventListener("load", onLoad, { once: true });
            existingScript.addEventListener("error", onError, { once: true });
            return;
        }

        const script = document.createElement("script");
        script.id = KAKAO_POSTCODE_SCRIPT_ID;
        script.src = KAKAO_POSTCODE_SCRIPT_URL;
        script.async = true;
        script.onload = onLoad;
        script.onerror = onError;
        document.head.appendChild(script);
    });

    return kakaoPostcodeLoadPromise;
};
